import { IApiLeagueStrikeZones } from 'interfaces/team/IApiScheduleResponse';
import React from 'react';
import { Content, Example, ExampleDot, Title } from './StrikeZoneExplanationsStyles';
interface IProps {
  heightBasedStrikeZone: NonNullable<IApiLeagueStrikeZones['heightBasedStrikeZone']>;
}

const HeightBased: React.FC<IProps> = (props) => {
  const { heightBasedStrikeZone } = props;

  return (
    <div>
      <Title>Height based SZ</Title>
      <Content>
        Is calculated using the percentages set for this game and the height of the players. If a player's profile does not have a height,
        then a static sz will be used.
        <Example>
          <ExampleDot />
          <div>Example is based on a player that’s 72 inches tall</div>
        </Example>
      </Content>
    </div>
  );
};

export default HeightBased;
